/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV3ServiceGetfeedbackGet } from '../fn/feedback/api-v-3-service-getfeedback-get';
import { ApiV3ServiceGetfeedbackGet$Params } from '../fn/feedback/api-v-3-service-getfeedback-get';
import { apiV3ServiceGetfeedbackGet$Plain } from '../fn/feedback/api-v-3-service-getfeedback-get-plain';
import { ApiV3ServiceGetfeedbackGet$Plain$Params } from '../fn/feedback/api-v-3-service-getfeedback-get-plain';
import { apiV3ServiceSetfeedbackPost } from '../fn/feedback/api-v-3-service-setfeedback-post';
import { ApiV3ServiceSetfeedbackPost$Params } from '../fn/feedback/api-v-3-service-setfeedback-post';
import { FeedbackApiFrom } from '../models/feedback-api-from';

@Injectable({ providedIn: 'root' })
export class ApiFromFeedbackService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV3ServiceSetfeedbackPost()` */
  static readonly ApiV3ServiceSetfeedbackPostPath = '/api/v3/service/setfeedback';

  /**
   * Saving a client's feedback on a record from the transaction history.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceSetfeedbackPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceSetfeedbackPost$Response(params?: ApiV3ServiceSetfeedbackPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiV3ServiceSetfeedbackPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Saving a client's feedback on a record from the transaction history.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceSetfeedbackPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceSetfeedbackPost(params?: ApiV3ServiceSetfeedbackPost$Params, context?: HttpContext): Observable<void> {
    return this.apiV3ServiceSetfeedbackPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceGetfeedbackGet()` */
  static readonly ApiV3ServiceGetfeedbackGetPath = '/api/v3/service/getfeedback';

  /**
   * Obtaining customer feedback on an entry from the transaction history.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceGetfeedbackGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetfeedbackGet$Plain$Response(params?: ApiV3ServiceGetfeedbackGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<FeedbackApiFrom>> {
    return apiV3ServiceGetfeedbackGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtaining customer feedback on an entry from the transaction history.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceGetfeedbackGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetfeedbackGet$Plain(params?: ApiV3ServiceGetfeedbackGet$Plain$Params, context?: HttpContext): Observable<FeedbackApiFrom> {
    return this.apiV3ServiceGetfeedbackGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<FeedbackApiFrom>): FeedbackApiFrom => r.body)
    );
  }

  /**
   * Obtaining customer feedback on an entry from the transaction history.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceGetfeedbackGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetfeedbackGet$Response(params?: ApiV3ServiceGetfeedbackGet$Params, context?: HttpContext): Observable<StrictHttpResponse<FeedbackApiFrom>> {
    return apiV3ServiceGetfeedbackGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtaining customer feedback on an entry from the transaction history.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceGetfeedbackGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetfeedbackGet(params?: ApiV3ServiceGetfeedbackGet$Params, context?: HttpContext): Observable<FeedbackApiFrom> {
    return this.apiV3ServiceGetfeedbackGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<FeedbackApiFrom>): FeedbackApiFrom => r.body)
    );
  }

}
